import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { AnalyticsCardComponentImpl } from './analytics-card/analytics-card.component';
import {
  PlaceholderModule,
  GridModule,
  UtilitiesModule
} from '@coreui/angular';

@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    PlaceholderModule,
    GridModule,
    UtilitiesModule
  ],
  exports: [AnalyticsCardComponentImpl],
  declarations: [AnalyticsCardComponentImpl],
  providers: []
})
export class AnalyticsCardModule {}
